"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var classNames = require("classnames");
var React = require("react");
var bulma_1 = require("./../bulma");
function Container(_a) {
    var _b = _a.tag, tag = _b === void 0 ? 'div' : _b, props = tslib_1.__rest(_a, ["tag"]);
    var className = classNames('container', {
        'is-fluid': props.isFluid,
    }, props.className);
    var isFluid = props.isFluid, HTMLProps = tslib_1.__rest(props, ["isFluid"]);
    return React.createElement(tag, tslib_1.__assign({}, HTMLProps, { className: className }));
}
exports.Container = Container;
var HOC = bulma_1.withHelpersModifiers(Container);
exports.default = HOC;
//# sourceMappingURL=Container.js.map